import React, { Component } from "react";

// Renders a static text for error display purposes.
export default class HcSInlineError extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { error } = this.props;

        return error !== null ?
            <div className="hcs-error hcs-inline-error" dangerouslySetInnerHTML={{ __html: error ? error.message : "" }} /> : null;
    }
}